import { Modal, NoData } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { useCustomerSelector } from '@wajeez-web/stores/customers';
import { getMonthName } from '@wajeez-web/core/utils';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

export const UserConsumedContentModal = ({
  onClose,
  isOpen,
}: CommonModalProps<unknown>) => {
  const { userConsumedContent } = useCustomerSelector((s) => s.usersAnalytics);

  return (
    <Modal
      title="User Consumed Content"
      withScroll={true}
      onClose={onClose}
      open={isOpen}
    >
      <div className="text-center">
        <div className="grid grid-cols-6 py-2 gap-4 ">
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText text={'tables.columnTitles.Arabic Title'} />
            </div>
          </div>
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText text={'tables.columnTitles.Content Type'} />
            </div>
          </div>
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText text={'tables.columnTitles.Reading Date'} />
            </div>
          </div>
        </div>
        {userConsumedContent.length === 0 && (
          <div className="mt-4">
            {' '}
            <NoData />
          </div>
        )}
        {userConsumedContent?.map((content, index: number) => {
          return (
            <div className="grid grid-cols-6 py-2 gap-4 " key={index}>
              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {content.title}
                </div>
              </div>
              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {content.contentEntityType}
                </div>
              </div>
              {/* if year start is before 2021 return sad emoji with no data word */}

              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {content.year && content.year < 2021 ? (
                    <span role="img" aria-label="sad">
                      {' '}
                      No Data 😢
                    </span>
                  ) : (
                    <span>
                      {content.year} {getMonthName(content.month)}{' '}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default UserConsumedContentModal;
